import { TContentManagementItemRep } from "@/libs/services/banners/type";
import color from "@/styles/color";
import { GreyBorderBtn } from "@/styles/customStyle";
import { Box, Typography } from "@mui/material";
import React from "react";
import { removeStyleFontFamily } from "@/libs/common/string";

interface IExpandTextWTBProps {
  data: TContentManagementItemRep[];
  breakPoint: number;
}

function ExpandTextWTB({ data, breakPoint = 2 }: IExpandTextWTBProps) {
  const [isExpand, setIsExpand] = React.useState<boolean>(false);
  return (
    <Box
      sx={{
        display: "flex",
        padding: { xs: "16px", xl: "40px 32px" },
        borderRadius: { xs: "16px", xl: "24px" },
        width: "100%",
        backgroundColor: color.pink200,
        flexDirection: "column",
        gap: { xs: "8px" },
        transition:
          "margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, padding 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        ":last-of-type": {
          marginBottom: 0,
        },
      }}
    >
      {data.map((item, index) => (
        <Box
          key={`paragraph-item-${index + 1}`}
          sx={{
            display: index + 1 <= breakPoint || isExpand ? "flex" : "none",
            flexDirection: "column",
            gap: { xs: "8px" },
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "14px", sm: "14px", xl: "20px" },
              lineHeight: { xs: "21px", sm: "21px", xl: "30px" },
              color: color.black,
            }}
          >
            {item.Title || ""}
          </Typography>
          <Typography
            component={"article"}
            sx={{
              fontWeight: 400,
              fontSize: { xs: "10px", sm: "10px", xl: "16px" },
              lineHeight: { xs: "20px", sm: "22px", xl: "30px" },
              color: color.gray400,
              ">": {
                h1: {
                  fontWeight: 700,
                  fontSize: { xs: "14px", sm: "14px", xl: "20px" },
                  lineHeight: { xs: "21px", sm: "21px", xl: "30px" },
                },
                h2: {
                  fontWeight: 700,
                  fontSize: { xs: "12px", sm: "12px", xl: "18px" },
                  lineHeight: { xs: "21px", sm: "21px", xl: "30px" },
                },
                h3: {
                  fontWeight: 700,
                  fontSize: { xs: "10px", sm: "10px", xl: "16px" },
                  lineHeight: { xs: "21px", sm: "21px", xl: "30px" },
                },
                h4: {
                  fontWeight: 700,
                  fontSize: { xs: "10px", sm: "10px", xl: "16px" },
                  lineHeight: { xs: "21px", sm: "21px", xl: "30px" },
                },
                h5: {
                  fontWeight: 700,
                  fontSize: { xs: "8px", sm: "8px", xl: "14px" },
                  lineHeight: { xs: "21px", sm: "21px", xl: "30px" },
                },
                h6: {
                  fontWeight: 700,
                  fontSize: { xs: "8px", sm: "8px", xl: "12px" },
                  lineHeight: { xs: "21px", sm: "21px", xl: "30px" },
                },
                ul: {
                  paddingLeft: "25px",
                  listStyleType: "disc",
                },
                li: {
                  fontSize: { xs: "10px", sm: "10px", xl: "16px" },
                  lineHeight: { xs: "20px", sm: "22px", xl: "30px" },
                },
                ol: {
                  paddingLeft: "10px",
                  listStyleType: "decimal",
                },
                iframe: {
                  margin: "10px 0px 15px 0px",
                  width: "100%",
                },
                img: {
                  margin: "5px 0px 5px 0px"
                },
                blockquote: {
                  margin: "15px 0px"
                },
                "blockquote  p": {
                    fontSize: { xs: "12px", sm: "12px", xl: "18px" },
                    backgroundColor: "white",
                    borderLeft: "5px solid #F2332B",
                    paddingLeft: "8px",
                    display: "inline",
                    padding: "10px",
                  },
                a: {
                  color: "#1155cc",
                  textDecoration: "underline"
                },
                "*": {
                  ol: {
                    paddingLeft: "25px",
                    listStyleType: "disc",
                  },
                  ul: {
                    paddingLeft: "25px",
                    listStyleType: "disc",
                  },
                  li: {
                    fontSize: { xs: "10px", sm: "10px", xl: "16px" },
                    lineHeight: { xs: "20px", sm: "22px", xl: "30px" },
                  },
                  iframe: {
                    margin: "10px 0px 15px 0px",
                    width: "100%",
                  },
                  img: {
                    margin: "5px 0px 5px 0px"
                  },
                  blockquote: {
                    margin: "15px 0px"
                  },
                  "blockquote  p": {
                      fontSize: { xs: "12px", sm: "12px", xl: "18px" },
                      backgroundColor: "white",
                      borderLeft: "5px solid #F2332B",
                      paddingLeft: "8px",
                      display: "inline",
                      padding: "10px",
                  },
                  a: {
                      color: "#1155cc",
                      textDecoration: "underline"
                  },
                }
              },
            }}
            dangerouslySetInnerHTML={{
              __html: removeStyleFontFamily(item.Description) || "",
            }}
          ></Typography>
        </Box>
      ))}
      {breakPoint < data.length && (
        <GreyBorderBtn
          sx={{
            marginTop: "8px",
            fontSize: { xs: "16px", xl: "16px" },
            padding: "0px",
            height: { xs: "fit-content" },
            width: { xs: "fit-content" },
            border: { xs: "unset" },
            background: "transparent !important",
            color: `${color.red} !important`,
            textDecorationLine: { xs: "underline" },
            transition: "unset",
            ":active": {
              background: "transparent !important",
              boxShadow: "unset",
            },
            "& .MuiTouchRipple-root": {
              display: "none",
            },
          }}
          onClick={() => setIsExpand(!isExpand)}
        >
          <Typography
            component={"span"}
            sx={{
              fontWeight: 400,
              fontSize: { xs: "14px", sm: "14px", xl: "16px" },
              lineHeight: { xs: "21px", sm: "21px", xl: "28px" },
              background: color.redGradient,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {isExpand ? "อ่านน้อยลง" : "อ่านเพิ่มเติม"}
          </Typography>
        </GreyBorderBtn>
      )}
    </Box>
  );
}

export default ExpandTextWTB;
